import React from 'react'

import styles from './tableEmptyOverlay.scss'

export default class TableLoadingOverlay extends React.Component {
  render() {
    return (
      <div data-cy="loading-overlay" className={styles.container}>
        Fetching rows in this table...
      </div>
    )
  }
}
